import { Component, OnInit, ViewChild } from '@angular/core';
import { TimetableService, Departure } from 'ticket-sdk';
import { IonPopover, Platform, ToastController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { environment } from '@env';
import { DateService } from '@app/core/services/date.service';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-timetable',
  templateUrl: './timetable.page.html',
  styleUrls: ['./timetable.page.scss'],
})
export class TimetablePage implements OnInit {
  @ViewChild('datePopover') datePopover: IonPopover;

  arrivalLocation = 'Ekerö';
  departureDates: Date[] = [];
  departures: Departure[] = [];
  departureLocation = 'Slagsta';
  loading = false;
  maxDateString: string;
  minDateString: string;
  selectedDateString: string;

  constructor(
    private timeTableService: TimetableService, 
    private dateService: DateService,
    public platform: Platform,
    public toastController: ToastController
    ) { 
      this.setDateStringValues();
  }

  get currentYear() {
    return new Date().getFullYear();
  }
   
  get isMobile() {
    return this.platform.is('mobile');
  }

  get isProd(): boolean {
    return environment.production;
  }

  get selectedDate(): Date {
    return new Date(this.selectedDateString);
  }

  onChangeDepartureLocation() {
    if (this.departureLocation === 'Slagsta') {
      this.departureLocation = 'Ekerö';
      this.arrivalLocation = 'Slagsta';
    }
    else {
      this.departureLocation = 'Slagsta';
      this.arrivalLocation = 'Ekerö';
    }

    this.departureDates = this.getDatesFromDepartures(this.departures);
  }

  getDatesFromDepartures(departures: Departure[]): Date[] {
    const departureDates = departures.filter(departure => departure.departure.name.toLowerCase() === this.departureLocation.toLowerCase())
      .map(departure => {
        let departureTime = departure.time + ':00';
        departureTime = departure.time.replace(/-/g, '/');
        return new Date(departureTime);
      });

    return departureDates.filter(departureTime => {
      const now = new Date();
      if (this.dateService.isSameDay(now, departureTime) && departureTime.getTime() < now.getTime()) {
        return false;
      }
      else {
        return true;
      }
    });
  }

  getTimetable(date: Date) {
    const year: string = date.getFullYear().toString();
    let month: string = (date.getMonth() + 1).toString();
    let day: string = date.getDate().toString();

    if (month.length === 1) {
      month = '0' + month;
    }
    if (day.length === 1) {
      day = '0' + day;
    }

    const dateString = `${year}-${month}-${day}`;
    this.loading = true;
    this.timeTableService.getTimetable(dateString)
    .pipe(take(1))
    .subscribe({
      next: route => {
        this.departures = !!route.departuresByDate && route.departuresByDate.length > 0 ? route.departuresByDate[0].departures : [];
        this.departureDates = this.getDatesFromDepartures(this.departures);
      },
      error: error => {
        this.presentFetchDataErrorToast();
      },
    })
    .add(() => this.loading = false);
  }

  onDateChange(event){
    this.getTimetable(this.selectedDate);

    if (this.datePopover) {
      this.datePopover.dismiss();
    }
  }

  ngOnInit() {
    this.getTimetable(this.selectedDate);
  }

  setDateStringValues() {
    const today = dayjs();
    this.selectedDateString = today.toISOString();
    this.maxDateString = today.add(1, 'year').toISOString();
    this.minDateString = today.subtract(1, 'year').toISOString();
  }

  async presentFetchDataErrorToast() {
    const toast = await this.toastController.create({
      message: 'Ett okänt fel uppstod. Prova igen om en liten stund',
      color: 'danger',
      position: 'top',
      duration: 5000
    });
    toast.present();
  }

}
